import React, { Component } from 'react'
import withAuthorization from '../auth/session/withAuthorization';
import UserList from '../components/UserList';
import styles from '../css/Admin.module.css';

class Admin extends Component {

    constructor(props) {
        super(props);
        this.state = {
                email: '',
                password: '',
                project: '',
                error: '',
                loading: false,
                users: []
        };
    }

    onChange = event => {
        this.setState({
            [event.target.name]: event.target.value
        });
    };

    onSubmit = event => {
        const { email, password, project } = this.state;
        const { firebase } = this.props;

        firebase
            .signUp(email, password)
                .then(authUser => {
                    return firebase
                        .user(authUser.user.uid)
                        .set({
                            uid: authUser.user.uid,
                            project: project
                        });
                })
                .then(() => {
                    return firebase
                        .likes(project)
                        .set({
                            likes: 0,
                            total: 0
                        });
                })
                .then(() => {
                    return firebase
                        .projects(project)
                        .set({
                            data: []
                        })
                })
                .then((res) => {
                    this.setState({
                        email: '',
                        password: '',
                        project: '',
                        error: null
                    })
                })
            .catch(error => {
                this.setState({ error });
            });
        event.preventDefault();
    };

    componentDidMount() {
        const { firebase } = this.props;
        this.setState({ loading: true });

        firebase.users()
            .then((snapshot) => {
                snapshot.forEach(doc => {
                    this.setState({
                        users: [...this.state.users, doc.data()],
                        loading: false,
                    })
                });
            });
    }

    render() {
        const { email, password, project, error, loading, users } = this.state;
        const isInvalid = password.length <= 0 || email.length <= 0 || project.length <= 0;
        return (
            <div className={styles.module}>
                <h1 className={styles.header}>Kau Administration</h1>
                <div className={styles.addUser}>
                    <h2>Add User &amp; project</h2>
                    <form onSubmit={this.onSubmit} className={styles.addUserForm}>
                        <label htmlFor="email">Email</label>
                        <input 
                            type="email" 
                            name="email" 
                            value={email}
                            className={styles.email}
                            placeholder="text@example.com"
                            onChange={this.onChange} 
                        />

                        <label htmlFor="password">Password</label>
                        <input 
                            type="password" 
                            name="password"
                            value={password} 
                            className={styles.password}
                            placeholder="Password" 
                            onChange={this.onChange}
                        />
                        
                        <label htmlFor="project">Project</label>
                        <input 
                            type="text" 
                            name="project" 
                            value={project}
                            className={styles.project}
                            placeholder="Project name" 
                            onChange={this.onChange}
                        />

                        <button className={styles.button} type="submit" disabled={isInvalid}>Add user</button>
                        {error && <p className={styles.error}>{error.message}</p>}
                    </form>
                </div>
                <div className={styles.userList}>
                    <h2>Userlist</h2>
                    {loading && <div>Loading...</div>}
                    <UserList users={users} />
                </div>
            </div>
        )
    }
}


const condition = authUser => !!authUser;

export default withAuthorization(condition)(Admin);